"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.berabartio = void 0;
exports.berabartio = {
    "addresses": {
        "ProxyAdmin": "0x880009982273e6560B75F6E30174E48B503c9747",
        "Multicall2": "0x92D144A99bD3aB1177B8Df600769Ad5422DE7819",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0xb3C3A5A20EA20b9754A054666D475625552D5378",
        "FeedPriceOracle": "0x9b33E5CdeA4f486cbcf93a31729064E602BC5Ba2",
        "CompLogic": "0xb680a4EF4338bCD8935D8cB00A58d18bF4aA8378",
        "RedemptionManager": "0x2f8569Cf4C52F33Fb90497781Ee86404C16B800C",
        "Timelock": "0xC013D9534AD27ACd93d4D4b74Af40993A8cc05b4",
        "Comptroller": "0xd199bD89E3F75986bDc7E7Db8242143351f823a2",
        "sdrBERA": "0x87b1F60b667fAC28466e7906BF153dA94C8664fB",
        "BERA": "0x0000000000000000000000000000000000000000",
        "CErc20": "0x839E2eD18de2aF580c8788135ff0e8a4826BE035",
        "suErc20": "0x423a342E73E7e398D9EDf0471ca4CA30309E4aDF",
        "JumpRate#1": "0x985dD2a79f41c088dDD48Dfd005279e6c4E3E1Ef",
        "ZeroRate": "0x4b9cCD0238B9FA30138A029B7444172D86EbcDEb",
        "sdrUSDC": "0xDb84a42f23F2fcc91531DF06a48da5e3a970F1cf",
        "USDC": "0xd6D83aF58a19Cd14eF3CF6fe848C9A4d21e5727c",
        "sdrUSDT": "0x0401d53413E2D1CB11268c3117f4d328dD1F20a4",
        "USDT": "0x05D0dD5135E3eF3aDE32a9eF9Cb06e8D37A6795D",
        "sdrHONEY": "0x272f68F665760B0737A9715667a340b2bf9715A1",
        "HONEY": "0x0E4aaF1351de4c0264C5c7056Ef3777b41BD8e03",
        "sdrNECT": "0xfbb865Ae1B38Cc70f4FFe615A8BBF854D63EaEeA",
        "NECT": "0xf5AFCF50006944d17226978e594D4D25f4f92B40",
        "sdrsNECT": "0x9C3DeFbf878649e1b2b4EfF49d14c4a91E26a35a",
        "sNECT": "0x3a7f6f2F27f7794a7820a32313F4a68e36580864",
        "sdrWBTC_deprecated": "0xcD382dacA9114E08348DfF37a4b23Ce3132938bE",
        "WBTC_deprecated": "0x286F1C3f0323dB9c91D1E8f45c8DF2d065AB5fae",
        "sdrWBTC": "0x374170094aC9966254b828E6588aAa068bf77467",
        "WBTC": "0x2577D24a26f8FA19c1058a8b0106E2c7303454a4",
        "sdrWETH": "0xC37bf2C66B7B60206139485CeF05e35a2ab482b3",
        "WETH": "0xE28AfD8c634946833e89ee3F122C06d7C537E8A8",
        "sdriBGT": "0x4367c1dd399E7Af5ca8E296888eFB7f224167861",
        "iBGT": "0x46eFC86F0D7455F135CC9df501673739d513E982",
        "sdrsuUSD": "0x58773C15D134458a081aF70281050dFC36519426",
        "suUSD": "0x8BF591Eae535f93a242D5A954d3Cde648b48A5A8",
        "sdrsuETH": "0x79aa2e53a931c3621FD23971f55DB437Ac68BE93",
        "suETH": "0x1c22531AA9747d76fFF8F0A43b37954ca67d28e0",
        "sdrsuBTC": "0x3D40A48312315dd2b62263F90BC21e63D8190220",
        "suBTC": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0xDb84a42f23F2fcc91531DF06a48da5e3a970F1cf",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xd6D83aF58a19Cd14eF3CF6fe848C9A4d21e5727c",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0x0401d53413E2D1CB11268c3117f4d328dD1F20a4",
            "underlySym": "USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x05D0dD5135E3eF3aDE32a9eF9Cb06e8D37A6795D",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrHONEY",
            "ctokenAddr": "0x272f68F665760B0737A9715667a340b2bf9715A1",
            "underlySym": "HONEY",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x0E4aaF1351de4c0264C5c7056Ef3777b41BD8e03",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrNECT",
            "ctokenAddr": "0xfbb865Ae1B38Cc70f4FFe615A8BBF854D63EaEeA",
            "underlySym": "NECT",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xf5AFCF50006944d17226978e594D4D25f4f92B40",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsNECT",
            "ctokenAddr": "0x9C3DeFbf878649e1b2b4EfF49d14c4a91E26a35a",
            "underlySym": "sNECT",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x3a7f6f2F27f7794a7820a32313F4a68e36580864",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrWBTC_deprecated",
            "ctokenAddr": "0xcD382dacA9114E08348DfF37a4b23Ce3132938bE",
            "underlySym": "WBTC_deprecated",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x286F1C3f0323dB9c91D1E8f45c8DF2d065AB5fae",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrWBTC",
            "ctokenAddr": "0x374170094aC9966254b828E6588aAa068bf77467",
            "underlySym": "WBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2577D24a26f8FA19c1058a8b0106E2c7303454a4",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrWETH",
            "ctokenAddr": "0xC37bf2C66B7B60206139485CeF05e35a2ab482b3",
            "underlySym": "WETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xE28AfD8c634946833e89ee3F122C06d7C537E8A8",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdriBGT",
            "ctokenAddr": "0x4367c1dd399E7Af5ca8E296888eFB7f224167861",
            "underlySym": "iBGT",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x46eFC86F0D7455F135CC9df501673739d513E982",
            "assetGroupId": 5
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0x58773C15D134458a081aF70281050dFC36519426",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8BF591Eae535f93a242D5A954d3Cde648b48A5A8",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuETH",
            "ctokenAddr": "0x79aa2e53a931c3621FD23971f55DB437Ac68BE93",
            "underlySym": "suETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x1c22531AA9747d76fFF8F0A43b37954ca67d28e0",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0x3D40A48312315dd2b62263F90BC21e63D8190220",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrBERA",
            "ctokenAddr": "0x87b1F60b667fAC28466e7906BF153dA94C8664fB",
            "underlySym": "BERA",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#1",
            "contract": "JumpRateModelV2",
            "address": "0x985dD2a79f41c088dDD48Dfd005279e6c4E3E1Ef",
            "tokens": [
                "BERA",
                "USDC",
                "USDT",
                "HONEY",
                "NECT",
                "sNECT",
                "WBTC_deprecated",
                "WBTC",
                "WETH",
                "iBGT",
                "BERA"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.1",
            "jumpMultiplierPerYear": "3",
            "kink": "0.65"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0x4b9cCD0238B9FA30138A029B7444172D86EbcDEb",
            "tokens": [
                "suUSD",
                "suETH",
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=berabartio.js.map